import { post, get, baseURL } from "@/utils/request";

// Get Channels list'
export const getChannels = (params: any) => post(`/paymentChannel/list`, params);

// Deposit
export const withdraw = (params: any) => post(`/withdraw`, params);

export const withdrawSettingByUserID = (params: any) => post(`/withdrawSettings/getByUserID`, params);

export const addWithdrawSettings = (params: any) => post(`/withdrawSettings/addWithdrawSettings`, params);